<template>
  <div>
    <div class="select-song">
      <router-link :to="{ name: 'Selectsong', query: {userId: 123} }"
        ><img src="@/assets/img/アセット 49@3x.png"
      /></router-link>
    </div>
  </div>
</template>

<script>

export default {
  name: "Home",
  beforeCreate: function () {
    document.body.className = "home";
  },
};
</script>

<style>
body.home {
  background-image: url("~@/assets/img/アセット 46@3x.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
}
.select-song {
  clear: both;
}
.select-song img {
  width: 600px;
  margin-top: 180px;
}
</style>





// WEBPACK FOOTER //
// src/pages/Home.vue